// src/app/components/loan/pdf-modal/pdf-modal.component.ts
import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';

import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-pdf-modal',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule
],
  templateUrl: './pdf-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pdf-modal.component.scss']
})
export class PdfModalComponent {
  pdfUrl: SafeResourceUrl;

  constructor(
    private dialogRef: MatDialogRef<PdfModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data: { blob: Blob },
    private sanitizer: DomSanitizer
  ) {
    const url = URL.createObjectURL(this.data.blob);
      const urlWithZoom = `${url}#zoom=110`; // 200% zoom

    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(urlWithZoom);
  }

  close(): void {
    this.dialogRef.close();
  }
}